// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import FileSaver from 'file-saver'
import XLSX from 'xlsx';
import JSZip from 'jszip'
import XLSXS from "xlsx-style";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import 'vant/lib/index.css';
import * as echarts from 'echarts';
import draggable from "vuedraggable";
import CryptoJS from 'crypto-js'

import util from '../static/util'
import request_server from '../static/request_server'
import config from '../static/config'

Vue.prototype.$util = util;
Vue.prototype.$request = request_server;
Vue.prototype.$config = config;

import calculate from '../static/calculate'
import commondata from '../static/commondata'
import requiredata from '../static/requiredata'
import equipmentdata from '../static/equipmentdata'
import businessMode from '../static/business/businessMode'
import businessData from '../static/business/businessData'
import businessUtil from '../static/business/businessUtil'
import VueQrcodeReader from 'vue-qrcode-reader'

Vue.prototype.$FileSaver = FileSaver;
Vue.prototype.$XLSX = XLSX;
Vue.prototype.$XLSXS = XLSXS;

Vue.prototype.$calculate = calculate;
Vue.prototype.$commondata = commondata;
Vue.prototype.$requiredata = requiredata;
Vue.prototype.$equipmentdata = equipmentdata;
Vue.prototype.$businessMode = businessMode;
Vue.prototype.$businessData = businessData;
Vue.prototype.$businessUtil = businessUtil;
Vue.prototype.$JSZip = JSZip;
Vue.prototype.$echarts = echarts;
Vue.prototype.$crypto = CryptoJS;
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false;

Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(VueQrcodeReader);
Vue.component('draggable',draggable);

window.$appRouter = router

//注册全局组件
import EquipmentTableComponent from "@/components/instrument/EquipmentTableComponent.vue";
import SearchComponent from "@/components/instrument/SearchComponent.vue";
Vue.component('CommonSearch', SearchComponent);
Vue.component('common-table', EquipmentTableComponent);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js